export const DEFAULT_LAYOUT = "default";
